module.exports = __webpack_public_path__ + "img/ARS_1406.461a4514.jpg";